import {accounts} from '../data';
import {FaLinkedin} from 'react-icons/fa';
import {ReactNode} from 'react';
import {XTwitter} from "./icons/x-twitter";


type Props = {
  customClasses: string,
  showIconText: boolean
}

type SocialIcons = {
  [key: string]: ReactNode
}

function SocialMedia({customClasses = '', showIconText = false}: Props) {
  const icons: SocialIcons = {
    twitter: <XTwitter />,
    linkedin: <FaLinkedin/>,
  };
  return (
      <ul className={`${customClasses}`}>
        {accounts.map(item => {
          const key: string = `${item.key}`;
          return <li key={item.name} className="flex items-end font-bold"><a href={item.link}
                                                                             target="_blank"
                                                                             rel="noreferrer noopener"
                                                                              className="flex items-center"><span
          className="text-blue-500 text-2xl bg-white rounded flex">{icons[key]}</span> {showIconText && item.name}
        </a></li>;
      })
      }
    </ul>
  );
}

export default SocialMedia;